const rankingItems = [
  { rank: 1, title: '2026暑期档明星恋情大揭秘', heat: '987万', trend: '🔥' },
  { rank: 2, title: '网红带货翻车事件持续发酵', heat: '856万', trend: '📈' },
  { rank: 3, title: '热播综艺录制现场突发状况', heat: '743万', trend: '📈' },
  { rank: 4, title: '下半年最受期待影视剧大盘点', heat: '612万', trend: '🆕' },
  { rank: 5, title: '头部主播选品团队内部矛盾曝光', heat: '534万', trend: '📈' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-trophy-line text-sm"></i>
            热度排行
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            热度排行
          </h2>
          <p className="text-foreground-500 text-sm mt-2">本周最受关注的热门话题</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 px-5 md:px-6 py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <span
                  className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-accent-300 text-accent-900'
                      : item.rank === 3
                      ? 'bg-accent-200 text-accent-800'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 line-clamp-1">
                    {item.title}
                  </h3>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-400">{item.trend}</span>
                  <span className="text-xs font-medium text-accent-600 whitespace-nowrap">{item.heat}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}